import { useMemo } from 'react';
import { useAppStore } from '../stores';

export const useHouseholdList = () => {
  const { households, loading, error } = useAppStore(state => state.chores);

  // Logic: UI-ready helpers (The Specialist)
  const sortedHouseholds = useMemo(() => {
    return [...households].sort((a, b) => a.household.name.localeCompare(b.household.name));
  }, [households]);

  const isEmpty = households.length === 0;

  return {
    households: sortedHouseholds,
    loading,
    error,
    isEmpty,
  };
};